
import './style/branchComponents.css';
import { media } from '../../../dataSets/media';
import { useContext, useState } from 'react';
import { AppContext } from '../../../contextApi/ContextApi';

export default function BranchComponent({ item }) {
    const {accent_color, primary_color, secondary_color, openInGoogleMaps} = useContext(AppContext);
    const [openStatus] = useState(item?.isOpen);
    const [isHoverHeader, setIsHoverHeader] = useState(false);
    const deployDays=()=>{
        return item?.week?.map((day, inx)=>{
            return <li key={`showHours_li_${inx}`} className='showHours_li'>{day?.day} - {day?.isOpen? `${day?.startAt} - ${day?.endAt}` : "סגור"}</li>
        })
    }

    return (
        <div className='branch' dir='rtl' style={{backgroundColor:primary_color, border:`1px solid ${accent_color}`}}>
            <div className='cityHeaderDiv' onClick={()=>{openInGoogleMaps(`${item.address}, ${item.city}`)}} onMouseEnter={()=>{setIsHoverHeader(true)}} onMouseLeave={()=>{setIsHoverHeader(false)}} style={{backgroundColor:isHoverHeader?accent_color:primary_color, borderBottom:`0.5px solid ${accent_color}`}}>
                <h3 className='cityHeader' style={{color:isHoverHeader?primary_color:accent_color, textShadow:`3px 2px 3px ${secondary_color}`}}>{item.city}</h3>
            </div>

            <div onClick={()=>{openInGoogleMaps(`${item.address}, ${item.city}`)}} className='addressDiv'>
                <img className='branchesLocationLogo' src={media?.locationLogo} alt="location_logo" />
                <h4 className='addressHeader' style={{color:isHoverHeader?secondary_color:accent_color}}>{item.address}</h4>
            </div>

            <div className='hoursDiv'>
                <div className='hoursHeader'>
                    <img className='branchesClockLogo' src={media?.clockLogo} alt="clock_logo" />
                    <div className='showHours_div'>שעות פעילות :</div>
                </div>
                {openStatus ? <ul className='showHours_ul'>{deployDays()}</ul> : <h1 dir='rtl' style={{margin:"40px auto", color:accent_color, textShadow:`2px 2px 4px ${secondary_color}`}}>הסניף סגור זמנית</h1>}
            </div>
        </div>
    )
}
